import { formatCostAsNumber } from '../../format';
import { calculateGrandTotals } from '../CheckoutConfirmationContainer/dataParsers';

export const formatPhoneNumber = phoneNumber => {
  const withCountryCode = '1' + phoneNumber;

  const formattedPhoneNumber = withCountryCode.replace(/-/g, '');

  return formattedPhoneNumber;
};

export const formatCheckoutPurchasedData = orders => {
  const { orderTotal, totalPrice, discountAmount } = calculateGrandTotals(
    orders,
  );
  const customerInfo = {
    first_name: orders[0].customer.first_name,
    last_name: orders[0].customer.last_name,
    id: orders[0].customer.id,
    email: orders[0].customer.email,
    phone_number: formatPhoneNumber(orders[0].customer.phone_number),
  };
  const couponCode = orders[0].coupon_code;
  const orderDetails = orders.map(order => {
    const petItem = order.items.find(item => item.pet_id);

    return {
      id: order.id,
      order_price: petItem.price,
      discount_code: order.coupon_code,
      discount_amount: order.total_discount,
      total_price: order.total_price,
      sku: petItem.sku,
      zip: order.address.zip_code,
      state: order.address.state,
      city: order.address.city,
    };
  });

  return {
    order_details: {
      order_price: orderTotal,
      discount_amount: discountAmount,
      discount_code: couponCode,
      total_price: totalPrice,
      currency: 'USD',
      customer_info: customerInfo,
      orders: orderDetails,
    },
  };
};

export const formatCompletedOrderData = orders => {
  const { discountAmount, subtotal, totalTax } = calculateGrandTotals(orders);
  const couponCode = orders[0].coupon_code;

  const getItemCategory = (recipes = { dry: [], fresh: [] }) => {
    return recipes.dry.length && recipes.fresh.length
      ? 'mixed'
      : recipes.dry.length
      ? 'dry'
      : 'fresh';
  };

  const productDetails = orders.map(order => {
    const petItem = order.items.find(item => item.pet_id);
    return {
      order_id: order.id,
      id: petItem.pet_id,
      sku: petItem.sku,
      name: petItem.pet_name,
      price: petItem.price,
      quantity: petItem.quantity,
      category: getItemCategory(petItem.recipes),
    };
  });

  return {
    subtotal: formatCostAsNumber(subtotal),
    revenue: formatCostAsNumber(subtotal),
    tax: totalTax === '' ? 0 : formatCostAsNumber(totalTax),
    discount: formatCostAsNumber(discountAmount),
    coupon: couponCode,
    currency: 'USD',
    products: productDetails,
  };
};
